export enum PerformanceEvaluationStatus {
  'Not Started',
  'In Progress',
  'Manager Complete',
  'Presented to Employee',
    'Complete'
}